import FormattedMessage from 'I18n/components/FormattedMessage';
import formatName from 'I18n/utils/formatName';
import { getTypeAction, UnreachableI18nCaseError } from '../../utils/i18nUtils';
import { useApprovalContext } from '../../hooks/useApprovalContext';
import { ApprovalRules } from '../../types';
import { jsx as _jsx } from "react/jsx-runtime";
export function ApprovalSummaryI18nAllApproved() {
  const approval = useApprovalContext();
  if (!approval.data) {
    return null;
  }
  const {
    approvalType,
    approvalAction,
    stepCount
  } = approval.meta;
  const typeAction = getTypeAction(approvalType, approvalAction);
  const requesterFullName = formatName({
    firstName: approval.data.requester.firstName,
    lastName: approval.data.requester.lastName
  });
  const options = {
    count: stepCount,
    numberOfApprovers: stepCount,
    requesterFullName
  };

  // Set the count to 1 if the approval rule is ANY_CAN_APPROVE because only 1 user needs to approve.
  if (approval.data.approvalRules === ApprovalRules.ANY_CAN_APPROVE) {
    options.count = 1;
  }
  switch (typeAction) {
    case 'MARKETING_EMAIL-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalSummaryFullyApproved.MARKETING_EMAIL-PUBLISH.title",
          options: options
        });
      }
    case 'LANDING_PAGE-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalSummaryFullyApproved.LANDING_PAGE-PUBLISH.title",
          options: options
        });
      }
    case 'SITE_PAGE-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalSummaryFullyApproved.SITE_PAGE-PUBLISH.title",
          options: options
        });
      }
    case 'BLOG_POST-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalSummaryFullyApproved.BLOG_POST-PUBLISH.title",
          options: options
        });
      }
    case 'DEAL-MOVE_STAGE':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalSummaryFullyApproved.DEAL-MOVE_STAGE.title",
          options: options
        });
      }
    case 'KNOWLEDGE_ARTICLE-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalSummaryFullyApproved.KNOWLEDGE_ARTICLE-PUBLISH.title",
          options: options
        });
      }
    default:
      throw new UnreachableI18nCaseError(typeAction);
  }
}
export function ApprovalSummaryI18nPartiallyApproved() {
  const approval = useApprovalContext();
  if (!approval.data) {
    return null;
  }
  const {
    approvalType,
    approvalAction,
    pendingCount
  } = approval.meta;
  const typeAction = getTypeAction(approvalType, approvalAction);
  const options = {
    count: pendingCount
  };
  switch (typeAction) {
    case 'MARKETING_EMAIL-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalSummaryPartiallyApproved.MARKETING_EMAIL-PUBLISH.title",
          options: options
        });
      }
    case 'LANDING_PAGE-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalSummaryPartiallyApproved.LANDING_PAGE-PUBLISH.title",
          options: options
        });
      }
    case 'SITE_PAGE-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalSummaryPartiallyApproved.SITE_PAGE-PUBLISH.title",
          options: options
        });
      }
    case 'BLOG_POST-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalSummaryPartiallyApproved.BLOG_POST-PUBLISH.title",
          options: options
        });
      }
    case 'DEAL-MOVE_STAGE':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalSummaryPartiallyApproved.DEAL-MOVE_STAGE.title",
          options: options
        });
      }
    case 'KNOWLEDGE_ARTICLE-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalSummaryPartiallyApproved.KNOWLEDGE_ARTICLE-PUBLISH.title",
          options: options
        });
      }
    default:
      throw new UnreachableI18nCaseError(typeAction);
  }
}